import { CAF_URI } from '@config/envConfig';

const titlesMap = {};
export const isCafURI = (contextURI) => {
  return contextURI === CAF_URI;
};
window.isCafURI = isCafURI;

const getPageTitle = (pathname) => {
  return titlesMap[pathname] || pathname;
};

/**
 * Function to set custom user data obj on window for using it in Appd
 */
export const setCustomUserData = (userObj = {}) => {
  const { customUserData = {} } = window;
  window.customUserData = {
    ...customUserData,
    ...userObj,
  };
};

/**
 * Function to frame custom page title on window for using it in Appd
 */
export const setCustomPageName = (pathname) => {
  const pageTitle = getPageTitle(pathname);
  window.customPageTitle = pageTitle;
};

/**
 * Function to get customers screen resolution
 */
export const getScreenResolution = () => {
  const realWidth = window.screen.width * window.devicePixelRatio;
  const realHeight = window.screen.height * window.devicePixelRatio;
  return `${realWidth}x${realHeight}`;
};
